/**
 * @description Enum containing routes to all pages rendered by react-router
 */
export enum AllRoutes {
  Home = "/",
  Dashboard = "/dashboard",
  News = "/news",
  SignIn = "/sign-in",
  Projects = "/projects",
  Hours = "/hours",
}
